import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { Box } from "@whoosh/design-system/src/components/primitive";

import { ColumnHeader } from "./ColumnHeader";
import { ColumnHeaderRow_facilities$key } from "./__generated__/ColumnHeaderRow_facilities.graphql";

export const ColumnHeaderRow = ({
  facilityRefs,
  courseIds,
  width,
}: {
  facilityRefs: ColumnHeaderRow_facilities$key;
  courseIds: string[];
  width: number | "100%";
}) => {
  const facilities = useFragment(ColumnHeaderRowFragmentString, facilityRefs);
  return (
    <Box flexDirection="row" width={width}>
      {facilities
        .flatMap((facility) => facility.courses?.edges ?? [])
        ?.filter((e) => e?.node?.id && courseIds.includes(e.node.id))
        .map((edge) => {
          return edge?.node ? (
            <ColumnHeader key={edge.node.id} courseRef={edge?.node} />
          ) : null;
        })}
    </Box>
  );
};

export const ColumnHeaderRowFragmentString = graphql`
  fragment ColumnHeaderRow_facilities on Facility @relay(plural: true) {
    id
    name
    courses(courseIds: $courseIds) {
      edges {
        node {
          id
          ...ColumnHeader_course
        }
      }
    }
  }
`;
